<template lang="pug">
  div
    .alert.alert-info Complete the video to become a member!
    div(style="position: relative;")
      div.video-overlay(style="position: absolute; width: 100%; height: 100%;" v-if="state.matches('playing')")
      <vytia-player height="400" width="100%" :ytid="state.context.videoId" @ready="onPlayerReady" @playing="onPlayerPlaying" @ended="onPlayerEnded"></vytia-player>
</template>

<style scoped=""></style>

<script>
// import { ref, reactive, onMounted } from '@vue/composition-api';
import { createMachine } from 'xstate';
import { useMachine } from 'xstate-vue2';

const machine = createMachine({
  id: 'Video',
  initial: 'paused',
  context: {
    videoId: process.env.VUE_APP_MEMBERSHIP_VIDEO || '',
  },
  states: {
    paused: {
      on: {
        TOGGLE: 'playing',
      },
    },
    playing: {
      on: {
        TOGGLE: 'paused',
        END: 'end',
      },
    },
    end: {},
  },
});

export default {
  name: 'Video',
  props: {},

  setup(props, { emit }) {
    const { send, state } = useMachine(machine);
    // console.log(WelcomeState)
    const onPlayerReady = () => {};
    const onPlayerPlaying = () => {
      send('TOGGLE');
      // console.log('state', state.value);
    };
    const onPlayerEnded = () => {
      send('END');
      emit('ended');
    };
    return {
      send,
      state,
      onPlayerReady,
      onPlayerPlaying,
      onPlayerEnded,
    };
  },
};
</script>
